// extracted by mini-css-extract-plugin
module.exports = {"downloadImage":"CustomRow_downloadImage__3zPXO","failedImage":"CustomRow_failedImage__1Kv76","doneButton":"CustomRow_doneButton__2TJsY"};